export default "__VITE_ASSET__LgWOmfaX__"